module.exports = __webpack_public_path__ + "0-c013df1c1fb61d3b30bd.worker.js"